export enum IdentityStatus {
  UNVERIFIED,
  VERIFIED,
  PENDING,
}

export interface IPhoneCheckSuccessResponse {
  success: boolean;
  message: string;
  web_password_set: boolean;
  password_set: boolean;
}

export interface IGetTokenSuccessResponse {
  access_token: string;
  expires_in: number;
  message: "token";
  refresh_token: string;
  token_type: "Bearer";
  success: boolean;
}

export interface IRegisterConfirmPayload {
  phone: string;
  name: string;
  surname: string;
  client_secret: string;
  web_password: string;
  agreements: Array<number>;
  email?: string;
}

export interface IGenericSuccessResponse {
  success: boolean;
  message: string;
}

export interface IAuthClient {
  id: string;
  name: string | null;
  surname: string | null;
  phone: string;
  email: string;
  birth_date: string;
  identity_status: IdentityStatus;
}

export enum FastMenuKeyEnum {
  FISHMAN_TICKET = "fishman_ticket",
  CAR_INSURANCE = "car_insurance",
  TRANSFERS = "transfers",
  PENERGIJA = "penergija",
  GSM = "gsm",
  DONATE = "donate",
  E_VOUCHER = "e_voucher",
  CATEGORY = "category",
}

export enum FastMenuStatusEnum {
  ON = 1,
  OFF = 0,
}
export interface IFastMenuItem {
  title: string;
  key: FastMenuKeyEnum;
  status: FastMenuStatusEnum;
  id?: number;
}

interface IMaintenanceTime {
  from: string;
  to: string;
  duration: string;
}
export interface IClientInfo {
  id: string;
  type: string;
  active_cash_order_id: number;
  active_cash_order_sum: string;
  unseen_notifications: number;
  identity_status: number;
  agreed_with_policies: number;
  agreements_outdated: boolean;
  live_chat: boolean;
  maintenance_time: IMaintenanceTime;
  service_suggestion_enabled: boolean;
  fast_menu: Array<IFastMenuItem>;
  insurance_service_id: number;
  authentication_enabled: boolean;
  is_demo: number;
  perlas_energija_service_id: number;
  evoucher_providers: Array<VoucherProvidersEnum>;
  services_skip_to_validation: Array<number>;
  cart_sharing_text: string;
}

export enum VoucherProvidersEnum {
  ORANGE = "Orange",
  LYCA_MOBILE = "Lyca Mobile",
  PLAY = "Play",
  POLKOMTEL_PLUS = "Polkomtel Plus",
  TELEGROSIK = "Telegrosik",
  T_MOBILE = "T-Mobile",
}

export interface IUpdatePassword {
  success: string;
  message: string;
}

export interface IUpdatePasswordPayload {
  web_password: string;
  new_web_password: string;
  new_web_password_confirmation: string;
}

export interface IGetChangePasswordQuestion {
  meta: {
    success: string;
    message: string;
  };
}

export interface IGetChangePasswordQuestionPayload {
  phone: string;
}

export interface IChangePasswordSuccessResponse {
  message: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  access_token: string;
}

export interface IChangePasswordPayload {
  phone: string;
  web_password: string;
  answer: string;
  client_secret: string;
}
